'use client';
import React from 'react';
import Link from 'next/link';
import { Bell, Settings } from 'lucide-react';
import AppImage from '@/components/ui/AppImage';
import LucatConnectFamilyLogo from '@/components/ui/LucatConnectFamilyLogo';
import { MARIE_AVATAR_URL } from '@/lib/familyDemoData';

interface AppHeaderProps {
  unreadCount?: number;
}

export default function AppHeader({ unreadCount = 0 }: AppHeaderProps) {
  return (
    <header
      className="sticky top-0 z-40 bg-lucat-navy shadow-card"
      style={{
        paddingTop: 'env(safe-area-inset-top, 0px)',
        paddingLeft: 'max(16px, env(safe-area-inset-left, 16px))',
        paddingRight: 'max(16px, env(safe-area-inset-right, 16px))',
        paddingBottom: '0',
      }}
    >
      <div
        className="flex items-center justify-between w-full"
        style={{ minHeight: '68px' }}
      >
        {/* ── Logo LUCAT CONNECT Famille ── */}
        <div className="flex-1 min-w-0 flex items-center">
          <LucatConnectFamilyLogo />
        </div>

        {/* ── Icônes droite ── */}
        <div className="flex items-center flex-shrink-0" style={{ gap: '4px' }}>
          {/* Notifications */}
          <Link
            href="/alerts-screen"
            className="relative flex items-center justify-center rounded-full hover:bg-white/10 transition-colors"
            style={{ width: 40, height: 40 }}
            aria-label="Alertes et notifications"
          >
            <Bell size={20} className="text-white" />
            {unreadCount > 0 && (
              <span className="absolute top-1.5 right-1.5 min-w-[16px] h-4 bg-lucat-red text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </Link>

          {/* Paramètres */}
          <Link
            href="/settings"
            className="flex items-center justify-center rounded-full hover:bg-white/10 transition-colors"
            style={{ width: 40, height: 40 }}
            aria-label="Paramètres"
          >
            <Settings size={20} className="text-white" />
          </Link>

          {/* Avatar Marie */}
          <div className="rounded-full overflow-hidden border-2 border-lucat-green flex-shrink-0" style={{ width: 36, height: 36 }}>
            <AppImage
              src={MARIE_AVATAR_URL}
              alt="Marie Beaumont, utilisatrice connectée, femme souriante"
              width={36}
              height={36}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </header>
  );
}